export default __webpack_public_path__ + "static/media/Helm of the Ichorous.f5d8958f.jpg";